import { render, staticRenderFns } from "./CurrentProducts.vue?vue&type=template&id=745ca1ed&"
import script from "./CurrentProducts.vue?vue&type=script&lang=js&"
export * from "./CurrentProducts.vue?vue&type=script&lang=js&"
import style0 from "./CurrentProducts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports